import { Injectable, inject } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { from, Observable } from 'rxjs';
import { UserService } from '../../users/user.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  userService = inject(UserService)
  constructor() { }
  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return from(this.handle(req, next)) as Observable<HttpEvent<any>>;
  }

  async handle(req: HttpRequest<any>, next: HttpHandler) {
    let token = this.userService.getUser()?.token;
    let lang = this.userService.getCulture()
     if (token) {
      const authReq = req.clone({
        setHeaders: {
          Authorization: 'Bearer ' + token,
          "Accept-Language":(lang === "en"? "en-US": "ar-EG")
        },
      });

      return next.handle(authReq).toPromise();
    } else {
      const authReq = req.clone({
        setHeaders: {
          Authorization: '',
          "Accept-Language":(lang === "en"?"en-US":"ar-EG")
        },
      });
      return next.handle(authReq).toPromise();
    }
  }
}
